export default "__VITE_ASSET__BkSnG4ls__"